package one.healthium.onboarding.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HappyUsers(
    @SerialName("title") val title: String,
    @SerialName("image") val image: String,
)